import { ComponentType, ElementType } from "react";
import { classNames } from "../../utils/helpers"
import { BoxProps } from "../Box"

export interface HeadingProps extends BoxProps {
  /** specify a different Tag to be used instead of as if you want to get styles based on the as prop but render a different Tag  */
  component?: ComponentType | ElementType
}

const HEADING_CLASSES: {[key: string]: string} = {
  h1: "font-extrabold fluid-5xl",
  h2: "font-extrabold fluid-4xl",
  h3: "font-bold fluid-3xl md:fluid-4xl",
  h4: "font-bold fluid-2xl",
  h5: "font-bold fluid-xl",
  h6: "font-bold fluid-lg"
}

const Heading = ({ as = 'h1', component, className, children }: HeadingProps) => { 
  const Tag = component || as
  const styles = typeof as === 'string' ? HEADING_CLASSES[as] : HEADING_CLASSES.h1

  return <Tag className={classNames(styles, 'block', className)}>{ children }</Tag>
}

export default Heading